import axios from 'axios';

// const API_URL = 'http://localhost:8080/api/auth/';
const API_URL = 'https://back.rosters.ru/api/auth/';


class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'signin', {
                username: user.username,
                password: user.password
            })
            .then(response => {
                console.log("Server response:", response.data);

                if (response.status === 200 && response.data.accessToken) {
                    localStorage.setItem('user', JSON.stringify({
                        username: response.data.username,
                        accessToken: response.data.accessToken
                    }));
                    console.log("Saved user to localStorage:", localStorage.getItem('user'));
                } else {
                    console.error("Access token missing in server response.");
                }

                return response.data;
            })
            .catch(error => {
                console.error("Login error:", error.response?.data || error.message);
                throw error;
            });
    }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();
